module.exports = __webpack_public_path__ + "media/photos/term-bg-7-80be4d3b.jpg";